import { DisplayPosition } from '@/common/manager/position/display-position';
import React from 'react';
import { isArrayNotEmpty } from '@/common/util/util';
export const config = {
    position: [
        DisplayPosition.formDialog,
        DisplayPosition.form,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'FormItemSlot',
    formItemBeforeHandler: (formItem, config) => {
        const { formItemConfig, isDesign } = config || {};
        const { options } = formItemConfig || {};
        const { componentSlot } = options || {};
        const componentProps = formItem?.['x-component-props'];
        if (componentProps) {
            componentProps.getComponentSlot = () => {
                return componentSlot;
            };
            componentProps.componentSlot = undefined;
            if (isDesign) {
                componentProps._designStamp = Date.now();
            }
        }
    },
    formComponent: (props) => {
        const { getComponentSlot, useDetailValue } = props || {};
        const componentSlot = getComponentSlot?.();
        if (isArrayNotEmpty(componentSlot)) {
            return (<div>
          {componentSlot.map((item, index) => {
                    return React.cloneElement(item, {
                        value: props?.value,
                        onChange: props?.onChange,
                        key: index,
                        useDetailValue,
                        isFromFormItem: true,
                    });
                })}
        </div>);
        }
        return <div>{componentSlot}</div>;
    },
};
